<template>
  <div :class="`badge ${color? color:'white'}`" :style="badgeStyle">
    <v-icon
      v-if="show_icon && show_icon_cond"
      :class="!zoom?'badge-icon':''"
      :color="content_color"
      :size="iconSize"
      >
      {{show_icon}}
    </v-icon>
    <AIIcon
      v-if="icon && icon === 'ai_stop'"
      :width="`${iconSize - 2}px`"
      color="red"
      />
    <TIcon
      v-else-if="icon"
      :class="!zoom?'badge-icon':''"
      :name="icon"
      :color="content_color"
      :size="iconSize"
    />
    <!-- <v-icon
      v-else-if="icon"
      :class="!zoom?'badge-icon':''"
      :color="content_color"
      :size="iconSize"
      >
      {{icon}}
    </v-icon> -->
    <div
      class="badge-text font-weight-light"
      :style="textColor"
      v-if="text"
      >
      {{text}}
    </div>
  </div>
</template>
<script>
import AIIcon from '@/components/WorkBench/AIIcon.component.vue'
import TIcon from '@/components/Taktify/TIcon.component.vue';
import { TColor } from '@/mixins/TColor.mixin.js';

export default {
  components: {
    AIIcon,
    TIcon,
  },
  mixins: [TColor],
  props: ['color', 'icon', 'text', 'content_color', 'zoom', 'show_icon', 'show_icon_cond'],
  data: () => ({
  }),
  computed: {
    badgeStyle() {
      if (this.zoom) {
        return `height: ${17 * this.zoom}px;
                width: ${17 * this.zoom}px;
                right: ${-5 * this.zoom}px;
                top: ${-4 * this.zoom}px;`
      } else {
        return ''
      }
    },
    iconSize() {
      if (this.zoom) {
        return 16 * this.zoom
      } else {
        return 16
      }
    },
    textColor() {
      if (this.content_color) {
        return `color: ${this.getColor(this.content_color)}`
      } else {
        return ''
      }
    }
  }
}
</script>
<style scoped>
  .badge {
    position: absolute;
    height: calc(17px * var(--taktplan_zoom));
    width: calc(17px * var(--taktplan_zoom));
    right: calc(-5px * var(--taktplan_zoom));
    top: calc(-4px * var(--taktplan_zoom));
    /* right: -5px;
    top: -4px; */
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 100% !important;
    z-index: 1;
  }
  .badge-icon {
    zoom: var(--taktplan_zoom);
  }
  .badge-text {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-left: 1px;
    font-size: 11px;
  }
</style>
